module.exports = __webpack_public_path__ + "img/SADA_-03 (2).6725a533.png";